import { ITemplate } from "../../types/types";

export const GET_TEMPLATES = 'GET_TEMPLATES';
export const GET_TEMPLATES_SUCCESS = 'GET_TEMPLATES_SUCCESS';
export const GET_TEMPLATES_FAILED = 'GET_TEMPLATES_FAILED';

export const GET_TEMPLATE_DETAIL = 'GET_TEMPLATE_DETAIL';
export const GET_TEMPLATE_DETAIL_SUCCESS = 'GET_TEMPLATE_DETAIL_SUCCESS';
export const GET_TEMPLATE_DETAIL_FAILED = 'GET_TEMPLATE_DETAIL_FAILED';

export const SAVE_TEMPLATE = 'SAVE_TEMPLATE';
export const SAVE_TEMPLATE_SUCCESS = 'SAVE_TEMPLATE_SUCCESS';
export const SAVE_TEMPLATE_FAILED = 'SAVE_TEMPLATE_FAILED';

export const DOWNLOAD_TEMPLATE = 'DOWNLOAD_TEMPLATE';
export const DOWNLOAD_TEMPLATE_SUCCESS = 'DOWNLOAD_TEMPLATE_SUCCESS';
export const DOWNLOAD_TEMPLATE_FAILED = 'DOWNLOAD_TEMPLATE_FAILED';

export const APPROVE_TEMPLATE = "APPROVE_TEMPLATE"
export const APPROVE_TEMPLATE_SUCCESS = "APPROVE_TEMPLATE_SUCCESS";
export const APPROVE_TEMPLATE_FAILED = "APPROVE_TEMPLATE_FAILED";

export const DENY_TEMPLATE = "DENY_TEMPLATE"
export const DENY_TEMPLATE_SUCCESS = "DENY_TEMPLATE_SUCCESS";
export const DENY_TEMPLATE_FAILED = "DENY_TEMPLATE_FAILED";

export const DELETE_TEMPLATE = "DELETE_TEMPLATE"
export const DELETE_TEMPLATE_SUCCESS = "DELETE_TEMPLATE_SUCCESS";
export const DELETE_TEMPLATE_FAILED = "DELETE_TEMPLATE_FAILED";

export const REFRESH_ALL = "REFRESH_ALL";


export const getTemplatesAction = (payload: any) => ({
	type: GET_TEMPLATES,
	payload
});

export const getTemplatesSuccess = (payload: ITemplate[]) => ({
	type: GET_TEMPLATES_SUCCESS,
	payload
});

export const getTemplatesFailed = (payload: any) => ({
	type: GET_TEMPLATES_FAILED,
	payload
});

export const getTemplateDetailAction = (payload: { templateId: number }) => ({
	type: GET_TEMPLATE_DETAIL,
	payload
});

export const getTemplateDetailSuccess = (payload: ITemplate) => ({
	type: GET_TEMPLATE_DETAIL_SUCCESS,
	payload
});

export const getTemplateDetailFailed = (payload: any) => ({
	type: GET_TEMPLATE_DETAIL_FAILED,
	payload
});

export const saveTemplateAction = (payload: any) => ({
	type: SAVE_TEMPLATE,
	payload
});

export const saveTemplateSuccess = (payload: any) => ({
	type: SAVE_TEMPLATE_SUCCESS,
	payload
});

export const saveTemplateFailed = (payload: any) => ({
	type: SAVE_TEMPLATE_FAILED,
	payload
});

export const downloadTemplateAction = (templateId: number) => ({
	type: DOWNLOAD_TEMPLATE,
	templateId
});

export const downloadTemplateSuccess = () => ({
	type: DOWNLOAD_TEMPLATE_SUCCESS
});

export const downloadTemplateFailed = (payload: any) => ({
	type: DOWNLOAD_TEMPLATE_FAILED,
	payload
});

export const approveTemplateAction = (payload: any) => ({
	type: APPROVE_TEMPLATE,
	payload
});

export const approveTemplateSuccess = (payload: any) => ({
	type: APPROVE_TEMPLATE_SUCCESS,
	payload
});

export const approveTemplateFailed = (payload: any) => ({
	type: APPROVE_TEMPLATE_FAILED,
	payload
});

export const denyTemplateAction = (payload: any) => ({
	type: DENY_TEMPLATE,
	payload
});

export const denyTemplateSuccess = (payload: any) => ({
	type: DENY_TEMPLATE_SUCCESS,
	payload
});

export const denyTemplateFailed = (payload: any) => ({
	type: DENY_TEMPLATE_FAILED,
	payload
});

export const deleteTemplateAction = (id: number) => ({
	type: DELETE_TEMPLATE,
	id
});

export const deleteTemplateSuccess = (payload: any) => ({
	type: DELETE_TEMPLATE_SUCCESS,
	payload
});

export const deleteTemplateFailed = (payload: any) => ({
	type: DELETE_TEMPLATE_FAILED,
	payload
});

export const refreshAll = () => ({
	type: REFRESH_ALL,
})